var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nopage"},[_c('div',{staticClass:"title"},[_vm._v("404")]),_vm._v(" "),_c('div',{staticClass:"tips"},[_vm._v("\n    SORRY,PAGE NOT FOUND\n    "),_c('div',{staticClass:"second"},[_vm._v(_vm._s(_vm.second)+"s")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6884c59c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/404.vue
// module id = null
// module chunks = 